// Globale Aktivitätsanzeige (08/2026): zählt laufende Axios-Requests, damit
// der Nutzer IMMER sieht, dass etwas passiert (kein "eingefroren"-Gefühl).
// Hochfrequente Hintergrund-Polls sind ausgenommen, damit der Balken nicht
// dauerhaft flackert.
import axios from 'axios';

let pending = 0;
const listeners = new Set();
let installed = false;

// Diese Endpunkte pollen im Hintergrund und sollen den Balken NICHT auslösen.
const SILENT_PATTERNS = [
  '/admin/notifications',
  '/whatsapp/unread-count',
  '/health/status-banner',
  '/reprice-status',
  '/reprice-jobs',
  'push-status',
  'job-status',
  'last-attempt',
  '/appointments/day-audit',
  'reprice-status',
];

function isSilent(url) {
  const u = String(url || '');
  return SILENT_PATTERNS.some((p) => u.includes(p));
}

// Konkrete, verständliche Texte je nach Aktion (statt nur "läuft…").
const LABEL_RULES = [
  [/\/appointments\b/, (m) => (m === 'post' ? 'Termine werden gebucht…' : m === 'delete' ? 'Termine werden gelöscht…' : 'Termine werden geladen…')],
  [/invite|magic|einladung/i, () => 'Einladung wird versendet…'],
  [/whatsapp|\/wa\//i, () => 'WhatsApp-Nachricht wird gesendet…'],
  [/email|mail|resend|send/i, () => 'E-Mail wird gesendet…'],
  [/invoice|rechnung|billing/i, (m) => (m === 'post' ? 'Rechnung wird erstellt…' : 'Rechnungen werden geladen…')],
  [/payrexx|payment|zahlung|card|tokeniz/i, () => 'Zahlung wird verarbeitet…'],
  [/purchase|sell|verkauf|service-abo/i, () => 'Verkauf wird abgeschlossen…'],
  [/customers?\/.*\/profile|reprice/i, () => 'Änderungen werden gespeichert…'],
  [/login|auth/i, () => 'Anmeldung läuft…'],
  [/export|download|pdf/i, () => 'Datei wird erstellt…'],
];

function labelFor(config) {
  const url = String(config?.url || '');
  const method = String(config?.method || 'get').toLowerCase();
  for (const [re, fn] of LABEL_RULES) {
    if (re.test(url)) return fn(method);
  }
  if (method === 'post' || method === 'put' || method === 'patch') return 'Wird gespeichert…';
  return 'läuft…';
}

let currentLabel = 'läuft…';
export function getActivityLabel() { return currentLabel; }

function emit() {
  for (const cb of listeners) {
    try { cb(pending); } catch (_) { /* noop */ }
  }
}

export function getActivity() {
  return pending;
}

export function subscribeActivity(cb) {
  listeners.add(cb);
  cb(pending);
  return () => listeners.delete(cb);
}

export function installGlobalActivity() {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((config) => {
    if (!isSilent(config?.url)) {
      config.__activityTracked = true;
      pending += 1;
      currentLabel = labelFor(config);
      emit();
    }
    return config;
  });

  const settle = (config) => {
    if (config?.__activityTracked) {
      pending = Math.max(0, pending - 1);
      config.__activityTracked = false;
      emit();
    }
  };

  axios.interceptors.response.use(
    (response) => {
      settle(response?.config);
      return response;
    },
    (error) => {
      settle(error?.config);
      return Promise.reject(error);
    }
  );
}
